import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { coerceBoolean } from "@obg/ngx.global.evo";

import { LoginConfigService } from "../../../sdk";

@Component({
	selector: "obg-m-sm-forgot-password-container",
	templateUrl: "./sm-forgot-password.container.html",
	styleUrls: ["./sm-forgot-password.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SmForgotPasswordContainer {
	@HostBinding("class.obg-m-sm-forgot-password") hostCssClass = true;
	@HostBinding("attr.data-test-id") dataTestId = "forgot-password-container";

	@Input()
	@coerceBoolean()
	hideFooter = false;

	@Input()
	@coerceBoolean()
	customUsageEnabled = false;

	@Output() close = new EventEmitter();

	isSmsEnabled = this.loginConfigService.getResetPasswordBySmsEnabled();

	constructor(private loginConfigService: LoginConfigService) {}
}
